(function(){

    /*
    * Inizializzazione e configurazione Modale Newsletter
    * */
    const cfg = window.DLP_FVM || {};
    const delayMs = Number(cfg.delayMs) || 5000;
    const ttlDays = Number(cfg.ttlDays) || 90;
    const storageKey = cfg.storageKey || "dlp_fvm_v1";

    const pageId = Number(cfg.pageId) || 0;
    const excludedPageId = Number(cfg.excludedPageId) || 0;

    // Extra safety (anche se lato PHP non lo carichiamo in quella pagina)
    if (excludedPageId && pageId === excludedPageId) return;

    // Check "già visto" con scadenza
    if (hasValidFlag()) return;

    window.addEventListener(
        "load",
        () => {
            setTimeout(() => schedule(showModal), delayMs);
        },
        { once: true }
    );

    function hasValidFlag() {
        try {
            const raw = localStorage.getItem(storageKey);
            if (!raw) return false;

            const data = JSON.parse(raw);
            if (!data) return false;

            // ttlDays = 0 => per sempre
            if (ttlDays === 0) return true;

            const expiresAt = Number(data.expiresAt || 0);
            return expiresAt && Date.now() < expiresAt;
        } catch (e) {
            return false;
        }
    }

    function remember() {
        try {
            if (ttlDays === 0) {
                localStorage.setItem(storageKey, JSON.stringify({ forever: true }));
                return;
            }
            const expiresAt = Date.now() + ttlDays * 24 * 60 * 60 * 1000;
            localStorage.setItem(storageKey, JSON.stringify({ expiresAt }));
        } catch (e) {}
    }

    function schedule(fn) {
        if ("requestIdleCallback" in window) {
            requestIdleCallback(fn, { timeout: 2000 });
        } else {
            setTimeout(fn, 0);
        }
    }

    function injectStyles() {
        if (document.getElementById("dlp-fvm-css")) return;
        const style = document.createElement("style");
        style.id = "dlp-fvm-css";
        style.textContent = `
            .dlp-fvm-overlay{position:fixed; inset:0; z-index:9999; display:flex; align-items:center; justify-content:center; background:rgba(0,0,0,.55); padding:16px;}
            .dlp-fvm-modal{width:min(640px, 100%); background:#fff; border-radius:16px; padding:4rem 5rem; text-align: center; box-shadow:0 20px 60px rgba(0,0,0,.25); position: relative; }
            .dlp-fvm-btn{position: absolute; top: 1rem; right: 1rem; width: 20px; height: 20px; display: inline-flex; align-items: center; justify-content: center;}
            html.dlp-fvm-open{ overflow:hidden; }
            @media (max-width: 767px){
                .dlp-fvm-modal{padding:3rem 3rem;}
            }
            @media (max-width: 575px){
                .dlp-fvm-modal{padding:2rem 1.5rem 3rem;}
            }
        `;
        document.head.appendChild(style);
    }

    function showModal() {
        if (document.getElementById("dlp-fvm")) return;

        injectStyles();

        const overlay = document.createElement("div");
        overlay.id = "dlp-fvm";
        overlay.className = "dlp-fvm-overlay";
        overlay.setAttribute("role", "dialog");
        overlay.setAttribute("aria-modal", "true");

        // Contenuto: tienilo leggero (niente immagini pesanti qui; se servono, lazy-load dopo apertura)
        overlay.innerHTML = `
            <div class="dlp-fvm-modal">
                <span class="dlp-fvm-btn dlp-fvm-btn--ghost" type="button" data-dlp-close>
                    <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_777_2177)"><path d="M12.5 3.5L3.5 12.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.5 12.5L3.5 3.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_777_2177"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>
                </span>
                <img src="wp-content/themes/delucapartners/dist/assets/attachments/images/newsletter.gif" class="img-fluid mb-3" style="max-width: 100px;" alt="">
                <h3 class="mb-4">Iscriviti alla nostra newsletter e scopri tutte le novità sul mondo del diritto del lavoro</h3>
                <div class="dlp-fvm-actions">
                    <a class="btn fullblue" href="/newsletter/" data-dlp-cta>Iscriviti ora</a>
                </div>
            </div>
        `;

        const close = () => {
            document.documentElement.classList.remove("dlp-fvm-open");
            overlay.remove();
            remember();
        };

        overlay.addEventListener("click", (e) => {
            if (e.target === overlay) close();
        });

        const btnClose = overlay.querySelector("[data-dlp-close]");
        if (btnClose) btnClose.addEventListener("click", close);

        document.addEventListener(
            "keydown",
            (e) => {
                if (e.key === "Escape") close();
            },
            { once: true }
        );

        document.body.appendChild(overlay);
        document.documentElement.classList.add("dlp-fvm-open");
    }

})();
